import * as metStateUtils from '../../../../store/util/metaStateUtils';
import * as searchConstants from '../searchConstants';


import {saveSearchRequestReducer} from './saveSearchRequestReducer';


const INITIAL_STATE = metStateUtils.withDefaultMetaState({
    _synced: true,
    searchRequests: {}
});


export default (state = INITIAL_STATE, action) => {

    switch (action.type) {


        case searchConstants.ACTION_SEARCH_REQUEST:

            return saveSearchRequestReducer(state, action.payload);


        default:

            return state;
    }
};
